import axios from "axios";
import { Capacitor } from "@capacitor/core";

export async function openPdf(router, url, options = {}) {
    try {
        const platform = Capacitor.getPlatform();

        if (platform === 'ios' || platform === 'android') {
            router.push({
                path: '/pdf-viewer'
                , query: {
                    apiUrl: url
                    , params: JSON.stringify(options.params || {})
                }
            });
            return;
        }
        const res = await axios.get(url, {
            responseType: 'blob'
            , ...options
        })

        const blob = new Blob([res.data], {
            type: 'application/pdf'
        })

        const pdfUrl = URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank');

        // メモリ解放
        setTimeout(() => {
            URL.revokeObjectURL(pdfUrl)
        }, 60_000);
    } catch(e) {
        alert('PDFの表示に失敗しました。');
    }
}

/**
 * アプリ（iOS/Android）ではアプリ内ビューアへ遷移し、PCでは別タブでPDFを開く
 * @param {object} router ルーター
 * @param {string} viewerPath アプリ内ビューアのパス
 * @param {string} pdfUrl PCで別タブに開くPDFのURL
 */
export function openPdfViewerOrNewTab(router, viewerPath, pdfUrl) {
    const platform = Capacitor.getPlatform();

    if (platform === 'ios' || platform === 'android') {
        router.push(viewerPath);
        return;
    }
    window.open(pdfUrl, '_blank');
}